import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and merges Tailwind classes intelligently.
 *
 * This is the standard utility function used by shadcn/ui components.
 * It handles:
 * - Conditional classes via clsx
 * - Deduplication and conflict resolution of Tailwind classes via tailwind-merge
 *
 * @example
 * cn('px-2 py-1', condition && 'bg-primary', 'px-4')
 * // If condition is true: 'py-1 bg-primary px-4' (px-4 overrides px-2)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
